import TypographyPrimaryScreen from './TypographyPrimaryScreen'

export default TypographyPrimaryScreen
